module.exports = ".butonAcition {\n  position: absolute;\n  top: 0%;\n  left: 14%; }\n"